import apiClient from "../../../network/apiClient";

export const addCategoryAPI = ( body ) => apiClient.post("/foodSection/create", body)
export const fetchCategoryAPI = () => apiClient.get("/foodSection/getAll", { handle404Silently: true })
export const deleteCategoryByIdAPI = ( id ) => apiClient.delete(`/foodSection/delete/${id}`)
export const updateCategoryByIdAPI = body => apiClient.put("/foodSection/update", body)